import React, { Component } from 'react';
import ImgDI from '../Images/Webinar-DI.jpg';



export class Webinar extends Component {
    constructor(props) {
        super(props);

        this.navegarRegistro = this.navegarRegistro.bind(this);

    }
    navegarRegistro() {
        window.open( "https://us22.list-manage.com/survey?u=418c31e87aceaf5bb5b2e9dbc&id=83345f88eb&attribution=false", "_blank");
    }

    render() {
        return (
            <div>

                <div>
                    <strong>
                        <center>
                            <h2>Próximas conferencias</h2>
                        </center>
                    </strong>

                </div>
                <div style={{ margin: "auto", width: "80%" }}>
                    <center>
                        <table>
                            
                            <tr>
                                <td rowSpan="4">
                                    <img style={{ maxWidth: "300px", margin: "15px" }} src={ImgDI} alt="Discapacidad intelectual"/>
                                </td>
                                <td colSpan="2"> <h3>Experiencias educativas: alumnos con discapacidad intelectual</h3>
                                </td>
                            </tr>
                            <tr>
                                <td> Impartido por:</td>
                                <td>
                                    <strong>
                                        Dra. ALEJANDRA FABIOLA RODRIGUEZ SAYAGO
                                    </strong>
                                </td>
                            </tr>
                            <tr>
                                <td>Fecha:</td>
                                <td>
                                    <strong>
                                        7 de Diciembre 9:00hrs.
                                    </strong>
                                </td>
                            </tr>
                            <tr>
                                <td>Costo:</td>
                                <td>
                                    <strong>
                                        GRATUITO
                                    </strong>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan="3">
                                    <center>
                                        <div style={{ backgroundColor: "cadetblue", color: "white", width: "350px", padding: "10px", margin: "20px", cursor: "pointer" }} onClick={this.navegarRegistro}>
                                            <center style={{ fontWeight: "bold", fontSize: "16pt" }}>
                                                Registrate aquí
                                            </center>
                                        </div>
                                    </center>
                                </td>
                            </tr>
                        </table>
                    </center>
                </div>
            </div>
        )
    }
}
export default Webinar;


// WEBPACK FOOTER //
// ./src/components/Webinars.js